var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6693 13.9997C25.6693 20.443 20.4459 25.6663 14.0026 25.6663M25.6693 13.9997C25.6693 7.55635 20.4459 2.33301 14.0026 2.33301M25.6693 13.9997H2.33594M14.0026 25.6663C7.55928 25.6663 2.33594 20.443 2.33594 13.9997M14.0026 25.6663C16.9208 22.4716 18.5791 18.3256 18.6693 13.9997C18.5791 9.67371 16.9208 5.52775 14.0026 2.33301M14.0026 25.6663C11.0844 22.4716 9.42606 18.3256 9.33594 13.9997C9.42606 9.67371 11.0844 5.52775 14.0026 2.33301M2.33594 13.9997C2.33594 7.55635 7.55928 2.33301 14.0026 2.33301",
    stroke: "url(#paint0_linear_3403_17)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3403_17",
    x1: 14.0027,
    y1: 25.9998,
    x2: 14.0027,
    y2: 1.99976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A28A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488572,
    stopColor: "#795B40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8152"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanet);
export default __webpack_public_path__ + "static/media/planet.972fa2fc0ee5b8b99ed58a5b51f40f37.svg";
export { ForwardRef as ReactComponent };